import React from 'react'
import ReactDOM from 'react-dom'
import camelcaseKeys from 'camelcase-keys'

import GlossaryEntries from '../components/glossary_entries';

document.addEventListener('DOMContentLoaded', () => {
  const elem = document.getElementById('glossary_entries');
  const data = camelcaseKeys(JSON.parse(elem.getAttribute('data')), { deep: true })

  ReactDOM.render(
    <GlossaryEntries 
      entries={data.glossaryEntries} 
      categories={data.categories} 
      keywords={data.keywords} 
      indexPath={data.indexPath} 
    />, 
    elem
  );
}, { once: true });
